import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {NavLink, Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {
    getInfomationAccountFromToken,
    checkRoleUser
} from '../../../utils/helper';
import {role} from '../../../utils/define';
import {URI_INTERNAL} from '../../../utils/pathLocations';
import {menuGroups} from '@app/routes';

import {useLocation} from 'react-router-dom';
import {userManager} from '@app/utils/oidc';
import {Get} from '@app/utils/httpProvider';
import {MAINTENANCE_EVENT_API} from '@app/utils/apiUrl';
// import { C } from 'node_modules/@fullcalendar/core/internal-common';

const MenuSidebar = () => {
    const [t] = useTranslation();
    // const account = getInfomationAccountFromToken();
    const [menuOpen, setMenuOpen] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const location = useLocation();
    // if (!location) return null;

    // 2) Lấy mappings + status
    const {listApiRoleMapping: mappings, status} = useSelector(
        (state) => state.apiRoleMapping
    );

    // 3) Trong khi đang loading, bạn có thể show skeleton hoặc trả về null
    // if (status === 'loading' || status === 'idle') {
    //     return (
    //         <aside className="main-sidebar sidebar-dark-primary elevation-4">
    //             <div className="sidebar">
    //                 <div style={{padding: '1rem', color: '#ccc'}}>
    //                     Đang tải menu...
    //                 </div>
    //             </div>
    //         </aside>
    //     );
    // }

    // local state for the current OIDC user
    const [oidcUser, setOidcUser] = useState(null);

    // load the user once on mount (and again whenever it silently renews)
    useEffect(() => {
        let mounted = true;

        // fetch the signed-in user (or null if not signed in)
        userManager.getUser().then((user) => {
            if (mounted) setOidcUser(user);
        });

        // listen for silent-renew events to keep our state in sync
        const onUserLoaded = (user) => setOidcUser(user);
        userManager.events.addUserLoaded(onUserLoaded);

        return () => {
            mounted = false;
            userManager.events.removeUserLoaded(onUserLoaded);
        };
    }, []);

    const [maintenanceAlerts, setMaintenanceAlerts] = useState({totalCount: 0});

    useEffect(() => {
        let isSubscribed = true;
        const fetchAlerts = async () => {
            try {
                const result = await Get(MAINTENANCE_EVENT_API.GET_ALERT_COUNTS);
                if (isSubscribed && result && result.totalCount !== undefined) {
                    setMaintenanceAlerts(result);
                }
            } catch (error) {
                // Thầm lặng bỏ qua lỗi nếu API chưa sẵn sàng hoặc token hết hạn
            }
        };

        fetchAlerts();
        const interval = setInterval(fetchAlerts, 5 * 60 * 1000); // 5 phút một lần

        return () => {
            isSubscribed = false;
            clearInterval(interval);
        };
    }, []);

    // extract the array of role names from the OIDC user profile
    const userRoles = oidcUser?.profile?.role
        ? Array.isArray(oidcUser.profile.role)
            ? oidcUser.profile.role
            : [oidcUser.profile.role]
        : [];

    // const havePermission = (controller) => {
    //     const maps = mappings.filter(
    //         (m) => m.controller.toLowerCase() === controller.toLowerCase()
    //     );
    //     if (!maps.length) return false;
    //     const allowed = maps.flatMap((m) =>
    //         m.lstAllowedRoles.map((r) => r.name)
    //     );
    //     return allowed.some((r) => userRoles.includes(r));
    // };

    const havePermission = (controller) => {
        if (controller.toLowerCase() === 'usagepurpose') return true;
        const maps = mappings.filter(
            (m) => m.controller.toLowerCase() === controller.toLowerCase()
        );

        if (!maps.length) return false;

        const allowed = maps.flatMap((m) =>
            m.lstAllowedRoles.map((r) => r.name)
        );

        return allowed.some((r) => userRoles.some(ur => ur.toLowerCase() === r.toLowerCase()));
    };

    const toggleMenu = (index) => {
        setMenuOpen((currentOpen) => ({
            ...currentOpen,
            [index]: !currentOpen[index]
        }));
    };

    const isRouteActive = (routePath, currentPath, siblingPaths = []) => {
        let matches = currentPath === routePath
            || currentPath.startsWith(routePath + '/')
            || currentPath.startsWith(routePath + '?');

        // Thêm trường hợp đặc biệt cho kiểm kê tài sản và phiếu đào thải tài sản
        if (!matches && routePath === URI_INTERNAL.INVENTORY_SESSION_PATH) {
            matches = currentPath === URI_INTERNAL.ASSET_DISPOSAL_PATH
                || currentPath.startsWith(URI_INTERNAL.ASSET_DISPOSAL_PATH + '/')
                || currentPath.startsWith(URI_INTERNAL.ASSET_DISPOSAL_PATH + '?');
        }

        if (!matches) return false;
        // Only yield to a sibling that has a LONGER (more specific) path and also matches
        const hasLongerSiblingMatch = siblingPaths
            .filter(p => p !== routePath && p.length > routePath.length)
            .some(p => {
                let siblingMatches = currentPath === p 
                    || currentPath.startsWith(p + '/') 
                    || currentPath.startsWith(p + '?');
                
                // Tránh việc nhầm lẫn với trường hợp đặc biệt
                if (!siblingMatches && p === URI_INTERNAL.INVENTORY_SESSION_PATH) {
                    siblingMatches = currentPath === URI_INTERNAL.ASSET_DISPOSAL_PATH
                        || currentPath.startsWith(URI_INTERNAL.ASSET_DISPOSAL_PATH + '/')
                        || currentPath.startsWith(URI_INTERNAL.ASSET_DISPOSAL_PATH + '?');
                }
                return siblingMatches;
            });
        return !hasLongerSiblingMatch;
    };

    const closeSidebarOnMobile = () => {
        if (document.body.classList.contains('sidebar-open')) {
            document.body.classList.remove('sidebar-open');
            document.body.classList.add('sidebar-collapse');
        }
    };

    return (
        <aside
            className="main-sidebar-modern sidebar-dark-primary elevation-4"
            style={{zIndex: '9993'}}
        >
            <Link to="/" className="brand-link" onClick={closeSidebarOnMobile}>
                <img
                    src="/img/logo.png"
                    alt="AdminLTE Logo"
                    className="brand-image img-circle elevation-3"
                    style={{opacity: '.8'}}
                />
                <span className="brand-text font-weight-light">
                    {/* {configData.NAME_OF_PROJECT} */}
                    CNTT 108
                </span>
            </Link>
            <div className="sidebar">
                <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                    <div className="image">
                        <img
                            src="/img/default-profile.png"
                            className="img-circle elevation-2"
                            alt="User"
                        />
                    </div>
                    <div className="info">
                        {/* <Link to="/profile" className="d-block">
                            {account.email ? account.email : account.username}
                        </Link> */}
                        <Link to="/profile" className="d-block" onClick={closeSidebarOnMobile}>
                            {oidcUser?.profile?.preferred_username || oidcUser?.profile?.email || 'Guest'}
                        </Link>
                    </div>
                </div>

                {/* Sidebar Search */}
                <div className="form-inline mt-2 px-3">
                    <div className="input-group" style={{ width: '100%' }}>
                        <input
                            className="form-control form-control-sidebar"
                            type="search"
                            placeholder="Tìm chức năng..."
                            aria-label="Search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ border: '1px solid #4b545c' }}
                        />
                        <div className="input-group-append">
                            <button className="btn btn-sidebar">
                                <i className="fas fa-search fa-fw" />
                            </button>
                        </div>
                    </div>
                </div>

                <nav className="mt-2">
                    <ul
                        className="nav nav-pills nav-sidebar flex-column"
                        role="menu"
                        data-accordion="false"
                    >
                        <li className="nav-item">
                            <NavLink to="/" exact className="nav-link" onClick={closeSidebarOnMobile}>
                                <i className="nav-icon fas fa-tachometer-alt" />
                                <p>{t('menusidebar.label.dashboard')}</p>
                            </NavLink>
                        </li>

                        {/* 2) Các nhóm động lấy từ menuGroups */}
                        {menuGroups.map((grp, idx) => {
                            // lọc ra các route con được phép
                            const allowed = grp.children.filter((r) =>
                                havePermission(r.controller)
                            );
                            if (allowed.length === 0) return null;

                            // const isGroupActive = allowed.some(
                            //     (r) => location.pathname === r.path
                            // );

                            // const isGroupActive = allowed.some((r) =>
                            //     location.pathname.startsWith(r.path)
                            // );
                            const siblingPaths = allowed.map(r => r.path);
                            const isGroupActive = allowed.some((r) =>
                                isRouteActive(r.path, location.pathname, siblingPaths)
                            );

                            // Search logic: if child matches, show group and force open
                            const hasMatchedChild = allowed.some(r => r.label.toLowerCase().includes(searchTerm.toLowerCase()));
                            if (searchTerm && !hasMatchedChild) return null;

                            const isExpanded = searchTerm ? true : menuOpen[idx];

                            return (
                                <li key={grp.title} className={`nav-item ${isExpanded ? 'menu-open' : ''}`}>
                                    <a
                                        className={`nav-link ${
                                            isGroupActive ? 'active' : ''
                                        }`}
                                        style={{cursor: 'pointer'}}
                                        onClick={() => toggleMenu(idx)}
                                    >
                                        <i className={`nav-icon ${grp.icon}`} />
                                        <p>
                                            {grp.title}
                                            {grp.title === 'Bảo trì' && maintenanceAlerts.totalCount > 0 && (
                                                <span className="badge badge-danger right ml-2 pulse-alert">
                                                    {maintenanceAlerts.totalCount}
                                                </span>
                                            )}
                                            <i
                                                className={`right fas fa-angle-${
                                                    isExpanded
                                                        ? 'down'
                                                        : 'left'
                                                }`}
                                            />
                                        </p>
                                    </a>
                                    <ul
                                        className={`nav nav-treeview ${
                                            isExpanded ? 'open' : ''
                                        }`}
                                        style={{
                                            display: isExpanded ? 'block' : 'none'
                                        }}
                                    >
                                        {allowed.map((r) => {
                                            const isMatched = r.label.toLowerCase().includes(searchTerm.toLowerCase());
                                            if (searchTerm && !isMatched) return null;
                                            
                                            return (
                                                <li
                                                    key={r.path}
                                                    className="nav-item"
                                                >
                                                    <NavLink
                                                        to={r.path}
                                                        className="nav-link"
                                                        isActive={(match, location) => isRouteActive(r.path, location.pathname, siblingPaths)}
                                                        activeClassName="active"
                                                        onClick={closeSidebarOnMobile}
                                                    >
                                                        <i className={`${r.icon || 'far fa-circle'} nav-icon`} />
                                                        <p>{r.label}</p>
                                                    </NavLink>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default MenuSidebar;
